export default "__VITE_ASSET__CKQum135__"